/** Retouren (Paket 1). */
import { api, post } from '../api';
import { liste, qs } from './http';
import type { RetoureAnmeldung, RetoureEingang, RetoureZeile } from './typen';

export const retouren = (f: { status?: string; q?: string } = {}) => liste<RetoureZeile>(`/retouren${qs(f)}`);
export const retoure = (id: string) => api<RetoureZeile>(`/retouren/${id}`);
export const retoureAnmelden = (d: RetoureAnmeldung) => post<RetoureZeile>('/retouren', d);
export const retoureEingang = (id: string, d: RetoureEingang) => post<RetoureZeile>(`/retouren/${id}/eingang`, d);
/** Ohne Positionen: prüft, dass alle Positionen einen Zustand haben → geprüft. */
export const retourePruefung = (id: string) => post<RetoureZeile>(`/retouren/${id}/pruefung`, {});
export const retoureAblehnen = (id: string, grund: string) => post<RetoureZeile>(`/retouren/${id}/pruefung`, { entscheidung: 'abgelehnt', grund });
/**
 * Leitung gibt die Erstattung frei. Erzeugt KEINE Gutschrift (R32): die Erstattung wird in
 * WooCommerce ausgelöst, die Gutschrift folgt automatisch aus der Woo-Erstattung.
 */
export const erstattungFreigeben = (id: string, betrag_cents: number) => post<RetoureZeile>(`/retouren/${id}/erstattung-freigeben`, { betrag_cents });

/** R37: Retourenlabel nur als Ausnahme der Leitung, Grund Pflicht; Mail mit Label an den Kunden. */
export const retourenlabelErzeugen = (id: string, grund: string, mail = true) => post<RetoureZeile>(`/retouren/${id}/retourenlabel`, { grund, mail });
export const retourenlabelPfad = (id: string) => `/retouren/${id}/retourenlabel.pdf`;
